import { MdInfoOutline } from 'react-icons/md'

import type { ReactElement } from 'react'
import type { IAnalyticTooltip } from '~/types/analytic'

import LinkButton from '~/components/Buttons/LinkButton'
import Tooltip from '~/components/Tooltip'

import './styles.scss'

interface Props {
  value?: IAnalyticTooltip
}

const AnalyticTooltip = ({ value }: Props): ReactElement => {
  /** Handlers */

  const handleLinkClick = (search: string) => () =>
    window.open(`${location.origin}/glossary?search=${search}`, '_blank')

  /** Render */

  return (
    <Tooltip
      mouseEnterDelay={0.2}
      overlay={
        <div className="analytics-tooltip-value-container">
          {value?.what ? (
            <div className="section">
              <div className="section-title">WHAT</div> {value.what}
            </div>
          ) : null}
          {value?.how ? (
            <div className="section">
              <div className="section-title">HOW</div> {value.how}
            </div>
          ) : null}
          {!!value?.glossarySearch?.length ? (
            <div className="section">
              <div className="links">
                Glossary:
                {value.glossarySearch.map((search, idx) => (
                  <LinkButton
                    key={`${search}-${idx}`}
                    label={search}
                    onClick={handleLinkClick(search)}
                    type="external"
                  />
                ))}
              </div>
            </div>
          ) : null}
        </div>
      }
      placement="top"
      trigger="hover"
    >
      <div className="analytics-tooltip-icon">
        <MdInfoOutline color="#aeaeae" role="icon" size={20} />
      </div>
    </Tooltip>
  )
}

export default AnalyticTooltip
